<script lang="ts">
	import SectionHeadline from './SectionHeadline.svelte';
	import Button from './Button.svelte';
	import Icon from './Icon.svelte';
	import NavigationExternalLink from '@icons/NavigationExternalLink.svelte';

	export let url: string;
</script>

<div class="relative overflow-hidden content-module-padding" {...$$restProps}>
	<div class="absolute top-6 lg:top-16 w-full opacity-0" id="termine" />

	<SectionHeadline class="mb-1.5">Termine</SectionHeadline>

	<div class="lg:pl-9 text-quaternary">
		<div class="mb-6">Hier geht es zur Anmeldung für die Termine:</div>

		<Button tag="a" href={url} target="_blank" rel="noopener noreferrer">
			<Icon component={NavigationExternalLink} class="mr-3" />
			Zu den Terminen
		</Button>
	</div>
</div>
